import { render, staticRenderFns } from "./SeverityEditDialog.vue?vue&type=template&id=663f485c"
import script from "./SeverityEditDialog.vue?vue&type=script&lang=js"
export * from "./SeverityEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports